import { Component } from '@angular/core';

@Component({
    selector: 'feedback-rating-control-header',
    templateUrl: 'feedback-rating-control-header.component.html',
    styleUrls: ['feedback-rating-control-header.component.scss'],
    standalone: false
})
export class FeedbackRatingControlHeaderComponent {}
